// Vue 3: vue-tour is not available for Vue 3
// This is a stub that provides no-op functionality
// If tour functionality is needed, consider using driver.js or vue3-tour

export default {
  install() {
    // No-op - vue-tour is not available for Vue 3.
    // If tour functionality is needed, consider using driver.js or vue3-tour.
  },
}
